var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.optionsInSelectedLanguage,"label":_vm.label,"dense":""},model:{value:(_vm.choiceInSelectedLanguage),callback:function ($$v) {_vm.choiceInSelectedLanguage=$$v},expression:"choiceInSelectedLanguage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }